// JS premium pour fast pills contextuelles (Gamme, Effet, Arôme) et dropdowns synchronisés

document.addEventListener('DOMContentLoaded', function () {
  // Définition des pills pour chaque filtre
  const pillsData = {
    gamme: ['CBD+', 'CBD', '0% THC', 'CBDX'],
    tags: ['Chill', 'Concentration', 'Cocooning'],
    aromes: ['Citron', 'Fleurs', 'Diesel']
  };

  // Génération des pills sous chaque select
  Object.keys(pillsData).forEach(filterKey => {
    const pillsContainer = document.querySelector(`.pills-quick[data-filter="${filterKey}"]`);
    if (!pillsContainer) return;
    pillsContainer.innerHTML = pillsData[filterKey].map(val =>
      `<button class="pill" data-value="${val}" data-filter="${filterKey}">${val}</button>`
    ).join('');
    pillsContainer.addEventListener('click', function(e) {
      if (!e.target.classList.contains('pill')) return;
      pillsContainer.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
      e.target.classList.add('active');
      // Désactive le select correspondant
      const select = document.getElementById(`filter-${filterKey}`);
      if (select) select.value = '';
      applyFilter(filterKey, e.target.dataset.value);
      // Désactive les autres selects et pills
      clearOtherFilters(filterKey);
    });
  });

  // Gestion des selects (dropdowns)
  ['gamme', 'tags', 'aromes'].forEach(filterKey => {
    const select = document.getElementById(`filter-${filterKey}`);
    if (!select) return;
    select.addEventListener('change', function() {
      // Désactive les pills associées
      const pillsContainer = document.querySelector(`.pills-quick[data-filter="${filterKey}"]`);
      if (pillsContainer) pillsContainer.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
      if (!select.value) {
        showAllProducts();
        return;
      }
      applyFilter(filterKey, select.value);
      clearOtherFilters(filterKey);
    });
  });

  // Fonction de filtrage générique
  function applyFilter(filterKey, value) {
    // On cible uniquement les produits de la liste principale (évite d'impacter les carrousels)
    // On cible uniquement la vraie section principale produits (jamais le header)
    const mainList = document.querySelector('.bigpharma-product-box-all-products');
    const products = mainList ? mainList.querySelectorAll('.bigpharma-product') : [];
    products.forEach(prod => {
      let match = false;
      if (filterKey === 'gamme') {
        const gamme = prod.querySelector('.bigpharma-product--gamme-items');
        match = gamme && gamme.textContent.includes(value);
      } else if (filterKey === 'tags') {
        const tags = prod.querySelectorAll('.bigpharma-product-product-tag');
        match = Array.from(tags).some(t => t.textContent.includes(value));
      } else if (filterKey === 'aromes') {
        const aromes = prod.querySelectorAll('.bigpharma-product--aromes-item');
        match = Array.from(aromes).some(a => a.textContent.includes(value));
      }
      prod.style.display = match ? '' : 'none';
    });
  }

  // Désactive les autres selects et pills quand un filtre est actif
  function clearOtherFilters(activeKey) {
    ['gamme', 'tags', 'aromes'].forEach(filterKey => {
      if (filterKey !== activeKey) {
        const select = document.getElementById(`filter-${filterKey}`);
        if (select) select.value = '';
        const pillsContainer = document.querySelector(`.pills-quick[data-filter="${filterKey}"]`);
        if (pillsContainer) pillsContainer.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
      }
    });
  }

  // Affiche tous les produits
  function showAllProducts() {
    // Affiche tous les produits de la liste principale uniquement
    // On cible uniquement la vraie section principale produits (jamais le header)
    const mainList = document.querySelector('.bigpharma-product-box-all-products');
    const products = mainList ? mainList.querySelectorAll('.bigpharma-product') : [];
    products.forEach(prod => prod.style.display = '');
  }

  // Reset complet
  const resetBtn = document.getElementById('reset-filters');
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      document.querySelectorAll('.pills-quick .pill').forEach(p => p.classList.remove('active'));
      ['gamme', 'tags', 'aromes'].forEach(filterKey => {
        const select = document.getElementById(`filter-${filterKey}`);
        if (select) select.value = '';
      });
      showAllProducts();
    });
  }
});